import { Form, FormInstance, Upload } from "antd";
import { type UploadFile } from "antd/lib/upload";
import Image from "next/image";
import { type NamuFile } from "~/hooks/useFileUpload";
import { CloseOutlined } from "@ant-design/icons";
import SVGAtom from "~/components/Atoms/SVGAtom/SVGAtom";

type Props = {
  form: FormInstance<any>;
  imageFile?: NamuFile;
  originImageUrl: string;
  beforeUpload: any;
  handleRemove: any;
  fieldName: string;
  className: string;
  label?: string;
  required: boolean;
  isRound?: boolean;
};

export const FormProfileImageUpload = (props: Props) => {
  return (
    <Form form={props.form}>
      <Form.Item
        label={props.label}
        name={props.fieldName}
        valuePropName="namuFiles"
        rules={[{ required: props.required, message: "required" }]}
      >
        <div
          style={{
            position: "relative",
          }}
          className={props.className}
          onClick={() =>
            props.imageFile?.fileUrl && props.handleRemove(props.imageFile)
          }
        >
          {props?.imageFile?.fileUrl ? (
            <Image
              src={props?.imageFile?.fileUrl}
              fill
              objectFit="cover"
              alt=""
              className={`${props.isRound ? "rounded-full" : "rounded-md"}`}
            />
          ) : (
            <Upload
              maxCount={1}
              accept="image/*"
              listType="picture"
              showUploadList={false}
              beforeUpload={(file: UploadFile<any>) =>
                props.beforeUpload(file, props.fieldName)
              }
              className=" flex h-full w-full "
            >
              <Image
                src={props.originImageUrl}
                fill
                objectFit="cover"
                alt=""
                className={`${props.isRound ? "rounded-full" : "rounded-md"}`}
              />
            </Upload>
          )}
          <div className="absolute right-[3.5px] top-[3px]">
            {props.imageFile ? (
              <CloseOutlined className="rounded-full bg-white p-1 text-[10px]" />
            ) : (
              <SVGAtom iconName="edit" width={18} height={18} />
            )}
          </div>
        </div>
      </Form.Item>
    </Form>
  );
};
